<ion-item class="ion-no-padding process-flags" lines="none">
  <div>
    <ng-container *ngIf="showSkipTwoPlusTwoCoachingEvaluation && processType === ProcessType.GoalsReview">
      <ion-item class="ion-no-padding process-flags" lines="none">
        <div>
          <ng-container *ngIf="processType === ProcessType.GoalsReview">
            <ion-toggle [(ngModel)]="version.skipTwoPlusTwoCoachingEvaluation" color="primary"></ion-toggle>
            <ion-label>{{ 'manageVersion.skipTwoPlusTwoFlag' | translate }}</ion-label>
          </ng-container>
        </div>
      </ion-item>
    </ng-container>
    <ng-container *ngIf="version.type === ProcessType.FreeEvaluationEndYear">
      <ion-col [size]="4">
        <ion-label> {{ 'manageVersion.blockThreeSixtyEvaluators' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.blockThreeSixtyEvaluators"></ion-toggle>
      </ion-col>
      <ion-col size="4">
        <ion-label> {{ 'manageVersion.blockLineManagerEvaluation' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.blockLineManagerEvaluation"></ion-toggle>
      </ion-col>
    </ng-container>
    <ng-container *ngIf="version.type === ProcessType.ThreeSixtyEvaluation">
      <ion-col>
        <ion-label> {{ 'manageVersion.optionalManagerEvaluation' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.optionalManagerEvaluation"></ion-toggle>
      </ion-col>
      <ion-col *ngIf="skipThreeSixtySelection">
        <ion-label> {{ 'manageVersion.skipSelectionStep' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.skipSelectionStep"></ion-toggle>
      </ion-col>
      <ion-col *ngIf="disableRelationColumn">
        <ion-label> {{ 'manageVersion.disableRelationColumn' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.disableRelationColumn"></ion-toggle>
      </ion-col>
      <ion-col *ngIf="userAttributesOnProcessAllowed">
        <ion-label> {{ 'manageVersion.userFilterByAttributes' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="userAttributesOnProcessAllowedFlag"
          (click)="changeAttributesOnProcessFlag()"></ion-toggle>
      </ion-col>
      <ion-col *ngIf="showThreeSixtyEvaluationLimit" style="max-height: 55px;">
        <ion-label> Limite de Avaliações </ion-label>
        <div style="display: flex;">
          <ion-toggle [(ngModel)]="version.enableValuationLimit"
            (ngModelChange)="onChangeThreeSixtyEvaluationLimit($event)"></ion-toggle>
          <small *ngIf="version.enableValuationLimit" (click)="openThreesixtyLimitModal()" style="cursor: pointer;">
            Selecionado:
            {{version.threeSixtyEvaluationLimit}} avaliações,
            {{version.threeSixtyEvaluationTimespanInHours}}horas
          </small>
        </div>
      </ion-col>
    </ng-container>
    <ng-container *ngIf="version.type === ProcessType.FinalFeedback">
      <ion-col>
        <ion-label> {{ 'manageVersion.hideAnswerToManager' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.hideAnswerToManager"></ion-toggle>
      </ion-col>
      <ion-col>
        <ion-label> {{ 'manageVersion.hideAnswerToUser' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.hideAnswerToUser"></ion-toggle>
      </ion-col>
      <ion-col>
        <ion-label> {{ 'manageVersion.onlyFinalFeedbackValidation' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.onlyFinalFeedbackValidation"></ion-toggle>
      </ion-col>
      <ion-col>
        <ion-label> {{ 'manageVersion.onlyFinalFeedbackSeeReviews' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.onlyFinalFeedbackSeeReviews"></ion-toggle>
      </ion-col>
    </ng-container>
    <ng-container *ngIf="version.type === ProcessType.ManagerEvaluation">
      <ion-col [size]="4">
        <ion-label> {{ 'manageVersion.seePreviousEvaluations' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="version.seePreviousEvaluations"></ion-toggle>
      </ion-col>
    </ng-container>
    <ng-container
      *ngIf="version.type === ProcessType.FreeEvaluationMidYear || version.type === ProcessType.FreeEvaluationEndYear">
      <ion-col>
        <ion-label> {{ 'manageVersion.manualReopening' | translate }}</ion-label>
        <ion-row class="manual-reopening">
          <ion-toggle [checked]="version?.manualReopeningTime !== null && version?.manualReopeningTime !== undefined"
            (ionChange)="toggleManualReopening($event)"></ion-toggle>
          <span>{{ version.manualReopeningTime ? version.manualReopeningTime : 0 }}</span>
          <span>{{ 'generic.hours' | translate | lowercase }}</span>
          <ion-icon class="bp-edit"
            [ngStyle]="{ 'cursor': version?.manualReopeningTime !== null && version?.manualReopeningTime !== undefined ? 'pointer' : 'default' }"
            (click)="editManualReopening()">
          </ion-icon>
        </ion-row>
      </ion-col>
    </ng-container>
  </div>
</ion-item>